import { App as CapacitorApp } from '@capacitor/app';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { createRoot } from 'react-dom/client';
import { ENV } from 'shared/ENV';
import { PermanentDataStore } from 'libs/storage';
import { App } from './App';
import '../css/index.css';
import '../css/react-spring-bottom-sheet.css';
import { history } from '../shared/history';
import { setDeviceInfo, setTextZoomCssVar } from '../shared/mobile';
import { applyPolyfills } from '../shared/polyfills';
import { initSentry } from '../shared/sentry';

// import for bundling
import '../i18n/config';

applyPolyfills();
setTextZoomCssVar();

const handleAndroidBackButton = (): void => {
  if (window.location.pathname !== '/') {
    history.goBack();
    return;
  }

  // Back button on home page closes app
  CapacitorApp.exitApp();
};

const init = async (): Promise<void> => {
  await Promise.all([initSentry(), setDeviceInfo()]);
  defineCustomElements(window);

  CapacitorApp.addListener('backButton', handleAndroidBackButton);
  const container = document.getElementById('root');
  const root = createRoot(container!);

  if (ENV.VITE_USE_NEW_STORAGE) {
    await PermanentDataStore.initialize();
  }

  root.render(
    /**
     * Strict mode only affects development builds, and it's currently breaking react-spring-bottom-sheet lib.
     * We can either disable it or be more specific in the components we want this feature on.
     * We should probably replace react-spring-bottom-sheet with a newer library that supports React v18.
     * Check this discussion for more context - https://github.com/facebook/react/issues/16362
     */
    // <React.StrictMode>
    <App />,
    // </React.StrictMode>
  );
};

init();
